import { Table, Button, Spinner, Badge } from 'react-bootstrap';
import type { Manual } from '../../../infrastructure/ManualClient';
import { formatDate } from '../../../utils/dateUtils';

interface ManualListProps {
  manuals: Manual[];
  loading: boolean;
  onView: (manual: Manual) => void;
  onEdit: (manual: Manual) => void;
  onDelete: (manual: Manual) => void;
}

export const ManualList = ({ manuals, loading, onView, onEdit, onDelete }: ManualListProps) => {
  if (loading) {
    return (
      <div className="text-center my-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  if (manuals.length === 0) {
    return (
      <div className="text-center my-5 p-5 bg-light rounded">
        <p className="mb-0">No manuals found. Create your first manual using the button above.</p>
      </div>
    );
  }

  return (
    <Table hover responsive className="align-middle">
      <thead>
        <tr>
          <th>Title</th>
          <th>Overview</th>
          <th>Sequences</th>
          <th>Last Updated</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {manuals.map((manual) => (
          <tr key={manual.manualId} onClick={() => onView(manual)} style={{ cursor: 'pointer' }}>
            <td>
              <div className="fw-bold">{manual.title}</div>
            </td>
            <td>
              <div className="text-truncate" style={{ maxWidth: '300px' }}>
                {manual.overview}
              </div>
            </td>
            <td>
              <Badge bg="info">{manual.sequences.length} steps</Badge>
            </td>
            <td>{formatDate(manual.updateAt)}</td>
            <td onClick={(e) => e.stopPropagation()}>
              <Button
                variant="outline-primary"
                size="sm"
                className="me-2"
                onClick={(e) => {
                  e.stopPropagation();
                  onView(manual);
                }}
              >
                View
              </Button>
              <Button
                variant="outline-secondary"
                size="sm"
                className="me-2"
                onClick={(e) => {
                  e.stopPropagation();
                  onEdit(manual);
                }}
              >
                Edit
              </Button>
              <Button
                variant="outline-danger"
                size="sm"
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete(manual);
                }}
              >
                Delete
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};
